export const buildPayload = (selectedItems) => {
  const companyItem = selectedItems.find((item) => !item.includes('-'));

  if (companyItem) {
    return {
      serviceCompanyId: Number(companyItem),
      houseIds: [],
      addressIds: [],
    };
  }

  const houseIds = [];
  const addressIds = [];

  for (const item of selectedItems) {
    const parts = item.split('-');

    if (parts.length === 2) {
      houseIds.push(Number(parts[1]));
      continue;
    }

    addressIds.push(Number(parts[parts.length - 1]));
  }

  return {
    serviceCompanyId: null,
    houseIds,
    addressIds,
  };
};
